export const topTabBarpadding = '11.51px 14.16px';
export const helperSideBarWidth = 280;
export const pageSizes = {
    A4: 'A4',
    A3: 'A3',
    A5: 'A5',
    Letter: 'Letter',
    Legal: 'Legal',
    Ledger: 'Ledger',
    B5: 'B5',
    C5: 'C5',
};

export const pageSizesDimensions = {
    [pageSizes.A4]: { width: 499, height: 670 },
    [pageSizes.A3]: { width: 531, height: 750 },
    [pageSizes.A5]: { width: 350, height: 499 },
    [pageSizes.Letter]: { width: 510, height: 680 },
    [pageSizes.Legal]: { width: 440, height: 750 },
    [pageSizes.Ledger]: { width: 900, height: 584 },
    [pageSizes.B5]: { width: 518, height: 726 },
    [pageSizes.C5]: { width: 460, height: 648 },
};
export const STANDARD_PAPER_SIZES_MM = {
    A3: { width: 297, height: 420 },
    A4: { width: 210, height: 297 },
    A5: { width: 148, height: 210 },
    Letter: { width: 215.9, height: 279.4 },
    Legal: { width: 215.9, height: 355.6 },
    Ledger: { width: 431.8, height: 279.4 },
    B5: { width: 176, height: 250 },
    C5: { width: 162, height: 229 },
};
